module.exports = __webpack_public_path__ + "static/media/NUR MARI.6b242eda.png";